import React, { useEffect, useState } from "react";
import PublicLayout from "@/components/PublicLayout";
import { api } from "@/lib/api";
import { Star } from "lucide-react";

export default function Testimonials() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/testimonials").then(({ data }) => setItems(data)); }, []);
  return (
    <PublicLayout>
      <section className="container-x pt-16 pb-16">
        <div className="overline mb-4">Success stories</div>
        <h1 className="font-display text-5xl md:text-6xl font-black tracking-tighter">Results from real students.</h1>
      </section>
      <section className="container-x pb-24 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.map((t) => (
          <div key={t.testimonial_id} className="glass rounded-2xl p-6" data-testid={`testimonial-${t.testimonial_id}`}>
            <div className="flex items-center gap-3">
              <img src={t.profile_image} alt={t.name} className="w-12 h-12 rounded-full object-cover" />
              <div><div className="font-medium">{t.name}</div><div className="text-xs text-ink-500">{t.role}</div></div>
            </div>
            <div className="flex gap-1 mt-4">{Array.from({length: t.rating || 5}).map((_,i)=><Star key={i} className="w-4 h-4 fill-gold text-gold" />)}</div>
            <p className="mt-3 text-ink-700 text-sm leading-relaxed">"{t.testimonial}"</p>
          </div>
        ))}
      </section>
    </PublicLayout>
  );
}
